import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import type { GroupPolicy } from '@atlassian/aiops-group-common';
import { fetch } from '@atlassian/eoc-fetch';

import type { SettingsFormValues } from '../../common/types';

export const getTeamGroupPolicy = (teamId: string): Promise<GroupPolicy> => {
	return fetch<GroupPolicy>(withAIOpsDomainPrefix(`/v1/policy/alert-groups/team/${teamId}`), {
		exactUrl: true,
	});
};

export const updateTeamGroupPolicy = (
	teamId: string,
	formValues: SettingsFormValues,
): Promise<GroupPolicy> => {
	return fetch<GroupPolicy>(withAIOpsDomainPrefix(`/v1/policy/alert-groups/update`), {
		exactUrl: true,
		method: 'PUT',
		body: { teamId, ...formValues },
	});
};

export const createTeamGroupPolicy = (
	teamId: string,
	formValues: SettingsFormValues,
): Promise<GroupPolicy> => {
	return fetch<GroupPolicy>(withAIOpsDomainPrefix(`/v1/policy/alert-groups/create`), {
		exactUrl: true,
		method: 'POST',
		body: { teamId, ...formValues },
	});
};
